import { FrownOutlined, LockOutlined, SmileOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Switch } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleSignIn } from '../../fetchHooks/handleSignIn';
import { SignupModal } from './SignupModal';
import styles from './login.module.css';
import { openNotification } from './openNotification';

const Login = () => {
  const { t } = useTranslation();
  const [showSignup, setShowSignup] = useState(false);

  const onFinish = async (values: any) => {
    // Remove all per-user tab keys at login as well
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith('mydayActiveTab_'))
      .forEach((k) => sessionStorage.removeItem(k));
    try {
      await handleSignIn(values);
      openNotification('Success', t('auth.loginSuccessful'), <SmileOutlined />);
      window.location.reload();
    } catch (error: any) {
      console.error('Login failed:', error);
      openNotification('Error', error.response?.data?.message || t('auth.loginFailed'), <FrownOutlined />);
    }
  };

  return (
    <div className={styles.container}>
      <div className="centered-container-content">
        <Row justify={'center'} align="middle" gutter={[100, 100]}>
          <div className="centered-text">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
              <h1 className={styles.title}>{t('common.welcomeTo')}</h1>
              <img src="/favicon.svg" alt="LifeLog Logo" className={styles.logo} />
            </div>
          </div>
        </Row>
        <Row justify={'center'} align="middle" gutter={[100, 100]}>
          <Col span={12}>
            <div className="centered-content">
              <Form name="normal_login" className="login-form" initialValues={{ remember: true }} onFinish={onFinish}>
                <Form.Item name="username" rules={[{ required: true, message: t('auth.username') }]}>
                  <Input
                    className="rounded-input"
                    size="large"
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder={t('auth.username')}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  style={{ marginBottom: 8 }}
                  rules={[{ required: true, message: t('auth.password') }]}
                >
                  <Input
                    className="rounded-input"
                    size="large"
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder={t('auth.password')}
                  />
                </Form.Item>
                <div className="centered-content" style={{ marginTop: 0 }}>
                  <Form.Item name="remember" noStyle style={{ margin: 0, padding: 0 }}>
                    <div className="styled-switch">
                      <Switch />
                      <span style={{ marginLeft: '1rem' }}>{t('auth.rememberMe')}</span>
                    </div>
                  </Form.Item>
                </div>

                <div className="centered-content">
                  <div style={{ textAlign: 'center' }}>
                    <button className="button login-button" type="submit">
                      {t('auth.login')}
                    </button>
                    <p>{t('common.or')}</p>
                    <button type="button" className="button styled-cancel-button" onClick={() => setShowSignup(true)}>
                      {t('auth.signup')}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
      <SignupModal show={showSignup} onCancel={() => setShowSignup(false)} />
    </div>
  );
};

export default Login;
